import {
  REGISTER_PAGE_ID,
  newAccount,
  newDeduction,
  getDeductionSources,
  getNumericFields
} from "../balances";

export default function BalancesSettings({
  balances,
  templateColumns,
  actionColumns,
  customMenus,
  updateBalances
}) {
  const accounts = balances?.accounts || [];
  const deductions = balances?.deductions || [];
  const pages = balances?.pages || [];

  const sources = getDeductionSources(actionColumns);
  const numericFields = getNumericFields(templateColumns);
  const pageOptions = [
    { id: REGISTER_PAGE_ID, label: "Реестр платежей" },
    ...customMenus.map((menu) => ({ id: menu.id, label: menu.label || "(без названия)" }))
  ];

  const setAccounts = (next) => updateBalances({ accounts: next });
  const setDeductions = (next) => updateBalances({ deductions: next });

  const patchAccount = (id, patch) =>
    setAccounts(accounts.map((a) => (a.id === id ? { ...a, ...patch } : a)));
  const patchDeduction = (id, patch) =>
    setDeductions(deductions.map((d) => (d.id === id ? { ...d, ...patch } : d)));

  const togglePage = (pageId, checked) =>
    updateBalances({
      pages: checked ? [...new Set([...pages, pageId])] : pages.filter((p) => p !== pageId)
    });

  return (
    <div className="balances-settings">
      <h1>Настройки</h1>

      <section className="balances-section">
        <div className="balances-section-head">
          <h2>Остатки на счетах</h2>
          <label>
            Дата
            <input
              type="date"
              value={balances?.date || ""}
              onChange={(e) => updateBalances({ date: e.target.value })}
            />
          </label>
        </div>

        <div className="balances-rows">
          {accounts.map((account) => (
            <div className="balances-row" key={account.id}>
              <input
                value={account.name}
                onChange={(e) => patchAccount(account.id, { name: e.target.value })}
                placeholder="Название счёта (KZT, Kaspi PAY…)"
              />
              <input
                value={account.amount}
                inputMode="decimal"
                onChange={(e) => patchAccount(account.id, { amount: e.target.value })}
                placeholder="Остаток"
              />
              <button
                className="remove-column-btn"
                onClick={() => setAccounts(accounts.filter((a) => a.id !== account.id))}
              >
                Удалить
              </button>
            </div>
          ))}
        </div>

        <button className="secondary-action-btn" onClick={() => setAccounts([...accounts, newAccount()])}>
          Добавить счёт
        </button>
      </section>

      <section className="balances-section">
        <div className="balances-section-head">
          <h2>Вычеты (из платежей)</h2>
          <span>Если условие совпало — выбранный числовой столбец суммируется и вычитается из «Итого».</span>
        </div>

        <div className="balances-rows">
          {deductions.map((deduction) => (
            <div className="balances-row balances-row-deduction" key={deduction.id}>
              <input
                value={deduction.label}
                onChange={(e) => patchDeduction(deduction.id, { label: e.target.value })}
                placeholder="Название строки (Одобрено…)"
              />
              <select
                value={deduction.columnId ? `${deduction.columnId}::${deduction.value}` : ""}
                onChange={(e) => {
                  const [columnId, value] = e.target.value.split("::");
                  patchDeduction(deduction.id, { columnId: columnId || "", value: value || "" });
                }}
              >
                <option value="">— если значение… —</option>
                {sources.map((source) => (
                  <option key={source.key} value={source.key}>{source.label}</option>
                ))}
              </select>
              <select
                value={deduction.field || "amount"}
                onChange={(e) => patchDeduction(deduction.id, { field: e.target.value })}
              >
                {numericFields.map((f) => (
                  <option key={f.key} value={f.key}>Суммировать: {f.label}</option>
                ))}
              </select>
              <select
                value={deduction.op || "minus"}
                onChange={(e) => patchDeduction(deduction.id, { op: e.target.value })}
              >
                <option value="minus">Минус (−)</option>
                <option value="plus">Плюс (+)</option>
              </select>
              <button
                className="remove-column-btn"
                onClick={() => setDeductions(deductions.filter((d) => d.id !== deduction.id))}
              >
                Удалить
              </button>
            </div>
          ))}
        </div>

        <button className="secondary-action-btn" onClick={() => setDeductions([...deductions, newDeduction()])}>
          Добавить вычет
        </button>
      </section>

      <section className="balances-section">
        <div className="balances-section-head">
          <h2>Где показывать блок</h2>
          <span>Отметьте страницы платежей, на которых виден блок остатков.</span>
        </div>

        <div className="balances-pages">
          {pageOptions.map((page) => (
            <label className="balances-page-option" key={page.id}>
              <input
                type="checkbox"
                checked={pages.includes(page.id)}
                onChange={(e) => togglePage(page.id, e.target.checked)}
              />
              {page.label}
            </label>
          ))}
        </div>
      </section>
    </div>
  );
}
